export const SCHEDULE_TYPE = 'schedule';
export const DEADLINE_TYPE = 'deadline';

export const PRIVATE = 'private';
export const PUBLIC = 'public';

export const HOURS = 'hours';
export const DAYS = 'days';
export const WEEKS = 'weeks';


export const PRIVACY_OPTIONS = [
    {
        title: 'storyboard.editor.schedule.privacy_private_title',
        description: 'storyboard.editor.schedule.privacy_private_description',
        id: PRIVATE
    },
    {
        title: 'storyboard.editor.schedule.privacy_public_title',
        description: 'storyboard.editor.schedule.privacy_public_description',
        id: PUBLIC
    }
];